import { render, staticRenderFns } from "./SearchResultSlug.vue?vue&type=template&id=75c2156b&scoped=true&"
import script from "./SearchResultSlug.vue?vue&type=script&lang=js&"
export * from "./SearchResultSlug.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultSlug.vue?vue&type=style&index=0&id=75c2156b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c2156b",
  null
  
)

export default component.exports